// App
export const GET_REVIEWS = 'getReviews'
export const GET_COUNTRY = 'getCountry'
export const GET_COUNTRIES = 'getCountries'

// Auth
export const FETCH_USER = 'fetchUser'
export const LOGIN = 'login'
export const UPDATE_USER = 'updateUser'
export const UPDATE_PASSWORD = 'updatePassword'
export const REQUEST_PASSWORD_RESET = 'requestPasswordReset'
export const CONFIRM_PASSWORD_RESET = 'confirmPasswordReset'
export const ANONYMISE_USER = 'anonymiseUser'

// Member
export const GET_ACTIVE_CAMPAIGNS = 'getActiveCampaigns'
export const NEW_GET_MEMBERS = 'newGetMembers'
export const GET_MEMBERS_WITH_HASH = 'getMembersWithHash'
export const NEW_GET_MEMBER = 'newGetMember'
export const CREATE_MEMBER = 'createMember'
export const UPDATE_MEMBER = 'updateMember'
export const UPDATE_ADDRESS = 'updateAddress'
export const STOP_MEMBER = 'stopMember'
export const PAUSE_MEMBER = 'pauseMember'
export const UPDATE_PRODUCT_GROUP_SIZE = 'updateProductGroupSize'
export const GET_CANCEL_MONTHS = 'getCancelMonths'
export const CREATE_MEMBER_ON_LANDINGPAGE = 'CreateMemberOnLandingPage'
export const NEW_CREATE_MEMBER_WITH_HASH = 'newCreateMemberOnLandingPage'
export const NEW_CREATE_MEMBER = 'newCreateMember'
export const ACTIVATE_PLEASE_STAY_OFFER = 'activatePleaseStayOffer'
export const GET_MEMBER_STATS = 'getMemberStats'
export const APPLY_FOR_RECURRENCE = 'applyForRecurrence'
export const REMOVE_RECURRENCE = 'removeRecurrence'
export const IS_ELIGIBLE_FOR_RECURRENCE = 'isEligibleForRecurrence'
export const GET_MEMBERSHIP_TYPE_BY_REFERENCE = 'getMembershipTypeByReference'
export const GET_UPSELL_PRODUCTS = 'getUpsellProducts'

// Orders
export const CREATE_RETURN_ORDER = 'createReturnOrder'
export const GET_AVAILABLE_PRODUCTS = 'getAvailableProducts'
export const GET_ORDER_BUNDLE = 'getOrderBundle'
export const GET_ORDER_BUNDLES = 'getOrderBundles'
export const CAN_DO_RETURN_REQUEST = 'canDoReturnRequest'
export const CREATE_RETURN_REQUEST = 'createReturnRequest'

// Payment
export const GET_OPEN_PAYMENTS = 'getOpenPayments'
export const NEW_GET_OPEN_PAYMENT = 'newGetOpenPayment'
export const NEW_GET_OPEN_PAYMENTS = 'newGetOpenPayments'
export const PAY_OPEN_PAYMENT = 'payOpenPayment'
export const RETRY_PAYMENT = 'retryPayment'
export const GET_BRAINTREE_CLIENT_TOKEN = 'getBraintreeClientToken'

// Payment Contract
export const GET_PAYMENT_CONTRACTS = 'getPaymentContracts'
export const GET_MEMBERSHIP_TYPES = 'getMembershipTypes'
export const GET_UPCOMING_WOMEN_SETS = 'getUpcomingWomenSets'

// User
export const SAVE_AVATAR = 'saveAvatar'
export const GET_REACTIVATABLE_MEMBERSHIPS = 'getReactivatableMemberships'
export const REACTIVATE_REACTIVATABLE_MEMBERSHIPS = 'reactivateReactivatableMemberships'
export const NEW_GET_PAYMENT_CONTRACT = 'newGetPaymentContract'
export const UPDATE_PAYMENT_METHOD = 'updatePaymentMethod'
export const DELETE_UNAUTHENTICATED_MEMBERSHIP = 'deleteUnauthenticatedMembership'
export const DELETE_SESSION = 'deleteSession'

// Homepage
export const GET_GOOGLE_RATING = 'getGoogleRating'

// Lookbook
export const GET_DESIGNS = 'getDesigns'
export const GET_SINGLE_DESIGN = 'getSingleDesign'

// Loqate
export const FIND_ADDRESS_SUGGESTIONS = 'findAddressSuggestions'
export const RETRIEVE_FULL_ADDRESS = 'retrieveFullAddress'
export const VERIFY_USER_INPUTTED_ADDRESS = 'verifyUserInputtedAddress'

// Spaaza
export const GET_PROSPECT_REFERRAL_CODE = 'getProspectReferralCode'
export const GET_SPAAZA_USER = 'getSpaazaUser'
export const GET_SPAAZA_WALLET = 'getSpaazaWallet'
export const GET_SPAAZA_WALLET_HISTORY = 'getSpaazaWalletHistory'

// Webshop
export const GET_PRODUCT_DETAILS = 'getProductDetails'
export const GET_PRODUCTS_OVERVIEW = 'getProductsOverview'
export const GET_SHIPPING_DETAILS = 'getShippingDetails'
export const CREATE_LOYALTY_ORDER_BUNDLE = 'createLoyaltyOrderBundle'
export const PAY_LOYALTY_ORDER_BUNDLE = 'payLoyaltyOrderBundle'
export const GET_LOYALTY_ORDER_INFORMATION = 'getConfirmationLoyaltyOrderBundle'
export const DELETE_PENDING_LOYALTY_CREDIT = 'deletePendingLoyaltyCredit'

// Signup
export const SIGNUP_GET_AVAILABLE_DESIGNS = 'signupGetAvailableDesigns'
export const SIGNUP_GET_LATEST_DESIGN = 'signupGetLatestDesign'
export const SIGNUP_CREATE_PROSPECT = 'signupCreateProspect'
export const SIGNUP_UPDATE_PROSPECT_ACCOUNT = 'signupUpdateProspectAccount'
export const SIGNUP_UPDATE_PROSPECT_ADDRESS = 'signupUpdateProspectAddress'
export const SIGNUP_UPDATE_MEMBERSHIP_TYPE = 'signupUpdateMembershipType'
export const SIGNUP_CREATE_VERIFICATION_PAYMENT = 'signupCreateVerificationPayment'
export const SIGNUP_GET_PROSPECT = 'signupGetProspect'
export const SIGNUP_USE_COUPON_CODE = 'signupUseCouponCode'
export const SIGNUP_ADD_WAITING_LIST = 'signupAddWaitingList'

// Flags
export const GET_FLAGS = 'getFlags'

// Security Delete Request
export const CREATE_DELETE_REQUEST = 'createDeleteRequest'
export const GET_DELETE_REQUEST = 'getDeleteRequest'
export const IS_ELIGIBLE_FOR_DELETE_REQUEST = 'isEligibleForDeleteRequest'

// Security Data Request
export const CREATE_DATA_REQUEST = 'createDataRequest'
export const GET_DATA_REQUEST = 'getDataRequest'
export const CONFIRM_DATA_REQUEST = 'confirmDataRequest'

// Feature flags
export const GET_FEATURE_FLAGS = 'getFeatureFlags'
